import React from 'react'

const Banner = () => {
  return (
    <div className="dlab-bnr-inr dlab-bnr-inr-sm overlay-black-middle" style={{backgroundImage:`url(../assets/images/banner/bnr3.jpg)`, height:'50px'}}>
    </div>
  )
}

export default Banner